import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { createCategory as universalCreateCategory, getCategory as universalGetCategory, updateCategory as universalUpdateCategory, deleteCategory as universalDeleteCategory, queryCategories as universalQueryCategories, listCompactCategoriesByIds as universalListCompactCategoriesByIds, searchCategories as universalSearchCategories, countCategories as universalCountCategories, moveCategory as universalMoveCategory, bulkCreateCategories as universalBulkCreateCategories, bulkUpdateCategories as universalBulkUpdateCategories, updateCategoryVisibility as universalUpdateCategoryVisibility, bulkUpdateCategoryVisibility as universalBulkUpdateCategoryVisibility, bulkUpdateCategoryVisibilityByFilter as universalBulkUpdateCategoryVisibilityByFilter, bulkDeleteCategories as universalBulkDeleteCategories, bulkDeleteCategoriesByFilter as universalBulkDeleteCategoriesByFilter, bulkAddItemsToCategory as universalBulkAddItemsToCategory, bulkAddItemToCategories as universalBulkAddItemToCategories, bulkRemoveItemsFromCategory as universalBulkRemoveItemsFromCategory, bulkRemoveItemFromCategories as universalBulkRemoveItemFromCategories, listItemsInCategory as universalListItemsInCategory, listCategoriesForItem as universalListCategoriesForItem, listTrees as universalListTrees, moveItemInCategory as universalMoveItemInCategory, setArrangedItems as universalSetArrangedItems, getArrangedItems as universalGetArrangedItems, getCategoriesTree as universalGetCategoriesTree, } from './categories-v1-category.universal';
import { NodeType, WidthType, PluginContainerDataAlignment, Type, Target, TextAlignment, LineStyle, Width, Alignment, ViewMode, LayoutType, Orientation, Crop, ThumbnailsAlignment, Source, MapType, ViewRole, VoteRole, PollLayoutType, PollLayoutDirection, BackgroundType, DecorationType, FontType, AppType, InitialExpandedItems, Direction, VerticalAlignment, NullValue, SingleEntityOpsRequestedFields, CommonSortOrder, RequestedFields, ValueAggregationSortType, ValueAggregationSortDirection, ValueAggregationMissingValues, CommonScalarType, NestedAggregationNestedAggregationType, DateHistogramAggregationInterval, CommonAggregationType, SearchDetailsMode, MoveCategoryRequestPosition, Position, WebhookIdentityType, } from './categories-v1-category.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.categories.v1.category', module_name: 'wix-categories.v2' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        createCategory: (category, options) => {
            const methodLogData = {
                method_name: 'createCategory',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.createCategory',
            };
            return universalCreateCategory(category, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getCategory: (categoryId, treeReference, options) => {
            const methodLogData = {
                method_name: 'getCategory',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.getCategory',
            };
            return universalGetCategory(categoryId, treeReference, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateCategory: (_id, category, options) => {
            const methodLogData = {
                method_name: 'updateCategory',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.updateCategory',
            };
            return universalUpdateCategory(_id, category, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        deleteCategory: (categoryId, treeReference) => {
            const methodLogData = {
                method_name: 'deleteCategory',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.deleteCategory',
            };
            return universalDeleteCategory(categoryId, treeReference, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryCategories: (options) => {
            const methodLogData = {
                method_name: 'queryCategories',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.queryCategories',
            };
            return universalQueryCategories(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listCompactCategoriesByIds: (categoryIds, options) => {
            const methodLogData = {
                method_name: 'listCompactCategoriesByIds',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.listCompactCategoriesByIds',
            };
            return universalListCompactCategoriesByIds(categoryIds, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        searchCategories: (options) => {
            const methodLogData = {
                method_name: 'searchCategories',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.searchCategories',
            };
            return universalSearchCategories(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        countCategories: (options) => {
            const methodLogData = {
                method_name: 'countCategories',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.countCategories',
            };
            return universalCountCategories(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        moveCategory: (categoryId, treeReference, options) => {
            const methodLogData = {
                method_name: 'moveCategory',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.moveCategory',
            };
            return universalMoveCategory(categoryId, treeReference, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkCreateCategories: (categories, options) => {
            const methodLogData = {
                method_name: 'bulkCreateCategories',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.bulkCreateCategories',
            };
            return universalBulkCreateCategories(categories, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkUpdateCategories: (categories, options) => {
            const methodLogData = {
                method_name: 'bulkUpdateCategories',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.bulkUpdateCategories',
            };
            return universalBulkUpdateCategories(categories, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateCategoryVisibility: (categoryId, options) => {
            const methodLogData = {
                method_name: 'updateCategoryVisibility',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.updateCategoryVisibility',
            };
            return universalUpdateCategoryVisibility(categoryId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkUpdateCategoryVisibility: (categoryIds, options) => {
            const methodLogData = {
                method_name: 'bulkUpdateCategoryVisibility',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.bulkUpdateCategoryVisibility',
            };
            return universalBulkUpdateCategoryVisibility(categoryIds, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkUpdateCategoryVisibilityByFilter: (filter, options) => {
            const methodLogData = {
                method_name: 'bulkUpdateCategoryVisibilityByFilter',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.bulkUpdateCategoryVisibilityByFilter',
            };
            return universalBulkUpdateCategoryVisibilityByFilter(filter, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkDeleteCategories: (categoryIds) => {
            const methodLogData = {
                method_name: 'bulkDeleteCategories',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.bulkDeleteCategories',
            };
            return universalBulkDeleteCategories(categoryIds, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkDeleteCategoriesByFilter: (filter, options) => {
            const methodLogData = {
                method_name: 'bulkDeleteCategoriesByFilter',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.bulkDeleteCategoriesByFilter',
            };
            return universalBulkDeleteCategoriesByFilter(filter, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkAddItemsToCategory: (categoryId, items, options) => {
            const methodLogData = {
                method_name: 'bulkAddItemsToCategory',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.bulkAddItemsToCategory',
            };
            return universalBulkAddItemsToCategory(categoryId, items, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkAddItemToCategories: (item, options) => {
            const methodLogData = {
                method_name: 'bulkAddItemToCategories',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.bulkAddItemToCategories',
            };
            return universalBulkAddItemToCategories(item, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkRemoveItemsFromCategory: (categoryId, items, options) => {
            const methodLogData = {
                method_name: 'bulkRemoveItemsFromCategory',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.bulkRemoveItemsFromCategory',
            };
            return universalBulkRemoveItemsFromCategory(categoryId, items, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkRemoveItemFromCategories: (item, options) => {
            const methodLogData = {
                method_name: 'bulkRemoveItemFromCategories',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.bulkRemoveItemFromCategories',
            };
            return universalBulkRemoveItemFromCategories(item, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listItemsInCategory: (categoryId, treeReference, options) => {
            const methodLogData = {
                method_name: 'listItemsInCategory',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.listItemsInCategory',
            };
            return universalListItemsInCategory(categoryId, treeReference, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listCategoriesForItem: (item, options) => {
            const methodLogData = {
                method_name: 'listCategoriesForItem',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.listCategoriesForItem',
            };
            return universalListCategoriesForItem(item, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listTrees: () => {
            const methodLogData = {
                method_name: 'listTrees',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.listTrees',
            };
            return universalListTrees(
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        moveItemInCategory: (categoryId, treeReference, options) => {
            const methodLogData = {
                method_name: 'moveItemInCategory',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.moveItemInCategory',
            };
            return universalMoveItemInCategory(categoryId, treeReference, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        setArrangedItems: (categoryId, treeReference, options) => {
            const methodLogData = {
                method_name: 'setArrangedItems',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.setArrangedItems',
            };
            return universalSetArrangedItems(categoryId, treeReference, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getArrangedItems: (categoryId, treeReference) => {
            const methodLogData = {
                method_name: 'getArrangedItems',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.getArrangedItems',
            };
            return universalGetArrangedItems(categoryId, treeReference, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getCategoriesTree: (treeReference) => {
            const methodLogData = {
                method_name: 'getCategoriesTree',
                service_name: 'com.wix.categories.api.v1.CategoriesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-categories.v2,entity=wix.categories.v1.category,environment=velo-frontend,method-fqn=com.wix.categories.api.v1.CategoriesService.getCategoriesTree',
            };
            return universalGetCategoriesTree(treeReference, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        NodeType,
        WidthType,
        PluginContainerDataAlignment,
        Type,
        Target,
        TextAlignment,
        LineStyle,
        Width,
        Alignment,
        ViewMode,
        LayoutType,
        Orientation,
        Crop,
        ThumbnailsAlignment,
        Source,
        MapType,
        ViewRole,
        VoteRole,
        PollLayoutType,
        PollLayoutDirection,
        BackgroundType,
        DecorationType,
        FontType,
        AppType,
        InitialExpandedItems,
        Direction,
        VerticalAlignment,
        NullValue,
        SingleEntityOpsRequestedFields,
        CommonSortOrder,
        RequestedFields,
        ValueAggregationSortType,
        ValueAggregationSortDirection,
        ValueAggregationMissingValues,
        CommonScalarType,
        NestedAggregationNestedAggregationType,
        DateHistogramAggregationInterval,
        CommonAggregationType,
        SearchDetailsMode,
        MoveCategoryRequestPosition,
        Position,
        WebhookIdentityType,
    };
}
//# sourceMappingURL=categories-v1-category.frontend.js.map